// extracted by mini-css-extract-plugin
module.exports = {"root":"login_root__ZI8jt","title":"login_title__RF7yc","form":"login_form__1aO-F","submitButton":"login_submitButton__38k_e","linkButton":"login_linkButton__3bUjY"};